import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteReplacementTransportPlanById,
  fetchReplacementTransportPlanById,
} from "../../../../lib/api/resources/replacementTransports";
import { ReplacementTransportPlanDetailCard } from "./components/ReplacementTransportPlanDetailCard";

export const ReplacementTransportPlanDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const replacementTransportPlanQuery = useQuery({
    queryKey: ["replacementTransportPlan", id],
    queryFn: () => fetchReplacementTransportPlanById(id),
  });

  const deleteReplacementTransportPlanMutation = useMutation({
    mutationFn: () => deleteReplacementTransportPlanById(id),
    onSuccess: () => {
      navigate(`/replacement-transport/plans`);
      message.success("Vervangend vervoer plan succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de vervangend vervoer plan",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ReplacementTransportPlanDetailCard
              deleteMutation={deleteReplacementTransportPlanMutation}
              replacementTransportPlan={replacementTransportPlanQuery.data}
              isLoading={replacementTransportPlanQuery.isFetching}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
